import Vue from 'vue'
import FastClick from 'fastclick'
// import VueRouter from 'vue-router'
import router from './router'
import App from './App'
import jK from './assets/js/common'

window.jK = jK;//微信控制台调试快速对象 正式上线删除
window.landingPageUrl = window.location.href;
// Vue.use(VueRouter)

// const routes = [{
//   path: '/',
//   component: App
// }]

// const router = new VueRouter({
//   routes
// })

jK.rem_init();

FastClick.attach(document.body)

Vue.config.productionTip = false;

/* eslint-disable no-new */
// new Vue({
//   router,
//   render: h => h(App)
// }).$mount('#app-box')


if(window.location.href.indexOf('localhost')>=0||window.location.href.indexOf('192.168.')>=0){
  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app-box')
}
else{
  jK.ajax({
    op:"m=App&c=User&a=my_info",
    send:{},
    callback(data){
      console.log(data)
      if(data.status==1){
        jK.store.set("userLoginData",data.data);
        new Vue({
            router,
            render: h => h(App)
          }).$mount('#app-box')
        }
      else{
        window.location.href='http://www.choicemedia.cn/a/index.php?m=App&c=Login&a=dologin';
      }
    }
  })
}




// WEBPACK FOOTER //
// ./src/main.js